import { useEffect, useRef } from "react";

const VIDEO = "jxi17F3z0Xw";
const START = 1;
const LENGTH = 10;

const loadApi = () => new Promise((resolve) => {
  if (window.YT?.Player) return resolve(window.YT);
  const prev = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = () => { prev?.(); resolve(window.YT); };
  if (!document.getElementById("yt-iframe-api")) {
    const s = document.createElement("script");
    s.id = "yt-iframe-api";
    s.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(s);
  }
  return undefined;
});

// Podyumda görünmez YouTube oynatıcı: şarkının 1. saniyesinden itibaren 10 sn döngü.
export const CelebrationMusic = () => {
  const host = useRef(null);
  useEffect(() => {
    let player;
    let iv;
    let alive = true;
    loadApi().then((YT) => {
      if (!alive || !host.current) return;
      player = new YT.Player(host.current, {
        videoId: VIDEO, width: 1, height: 1,
        playerVars: { autoplay: 1, start: START, controls: 0, playsinline: 1, disablekb: 1 },
        events: {
          onReady: (e) => { e.target.setVolume(70); e.target.seekTo(START, true); e.target.playVideo(); },
        },
      });
      iv = setInterval(() => {
        const t = player?.getCurrentTime?.();
        if (t != null && (t >= START + LENGTH || player.getPlayerState?.() === 0)) { player.seekTo(START, true); player.playVideo(); }
      }, 250);
    });
    return () => { alive = false; clearInterval(iv); player?.destroy?.(); };
  }, []);
  return (
    <div className="fixed -left-[9999px] top-0 h-px w-px overflow-hidden pointer-events-none" aria-hidden="true" data-testid="celebration-music">
      <div ref={host} />
    </div>
  );
};
